/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable max-lines */
import styled from 'styled-components'
import { navigate } from '@reach/router'
import React, { Fragment, useEffect, useState } from 'react'
import { Card, Select, RadioButton, RadioGroup, Input, StyleGuide, Toast } from '@taglivros/oef_componentes'

import { REQUIRED_MESSAGE, EVENTOS_GA, URLS } from '../../../../../constants'
import { empty, isEmptyObject } from '../../../../../utils/helpers/helpers'
import NumberInput from '../../../../../components/NumberInput'
import { useGlobal } from '../../../../../contexts/GlobalContext'
import Navegacao from '../components/Navegacao/Navegacao'
import NivelSatisfacao from '../components/NivelSatisfacao/NivelSatisfacao'
import {
  CODIGO_DEFAULT_MOTIVO,
  CODIGO_DEFAULT_SUBMOTIVO,
  LISTA_OPCOES,
  MENSAGEM_SATISFACAO_NAO_PREENCHIDA,
  PERGUNTA_MOTIVO_CANCELAMENTO,
  PERGUNTA_SUBMOTIVO,
  perguntaDisponibilidadeVolta,
  perguntaQuantidadeLivrosLidos
} from './constantsMotivosCancelamento'
import { BOTAO_CONCLUIR_CANCELAMENTO } from '../constantsCancelarAssinatura'
import { useSolicitacaoCancelamento } from '../../../../../contexts/SolicitacaoCancelamentoContext'
import { getAssinaturaDoAssociadoPorModalidade } from '../../../../../utils/helpers/helpersAssinatura'
import { enviaEventoGA } from '../../../../../utils/helpers/helpersGA'
import InlineLoader from '../../../../../components/InlineLoader/InlineLoader'

const CardWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .conteudoEsquerda,
  .conteudoDireita {
    padding: 40px 0;
    width: 46%;

    @media(max-width: ${StyleGuide.mediaQuery.mobile} ) {
      padding-bottom: 0;
      width: 100%;
    }
  }

  .conteudoEsquerda {
    @media(max-width: ${StyleGuide.mediaQuery.mobile} ) {
      padding-top: 0;

      &:nth-child(2) {
        margin-bottom: 20px;
      }
    }
  }

  .conteudoDireita {
    @media(max-width: ${StyleGuide.mediaQuery.mobile} ) {
      padding-top: 20px;

      .row:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  .row {
    margin-bottom: 40px;

    @media(max-width: ${StyleGuide.mediaQuery.mobile} ) {
      margin-bottom: 20px;
    }

    &.--voltar {
      margin-bottom: 20px;

      @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
        margin-bottom: 10px;
      }
    }

    &.--numero {
      margin-bottom: 20px;
    }

    .row--pergunta {
      ${StyleGuide.tipografia.textoDefault};
      margin: 0 0 15px;
    }

    label {
      ${StyleGuide.tipografia.textoDefault};
      z-index: 1;
    }

    input::placeholder,
    textarea::placeholder {
      ${StyleGuide.cores.cinza500};
      opacity: 0.4;
    }

    #motivo-cancelamento,
    #detalhes-motivo-cancelamento {
      height: 50px;
    }

    #pretende_voltar {

      @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
        display: flex;
        justify-content: space-between;
      }

      label {
        margin-right: 18px;
        padding-left: 10px;
      }

      p {
        margin: 0;
      }
    }
  }
`

const WrapperFormulario = styled.div`
  position: relative;
`

const LoadingWrapper = styled.div`
  align-items: center;
  background-color: rgba(255, 255, 255, .7);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 5;
`

const MotivosCancelamento = () => {
  const [ state, setState ] = useState( {
    'pretende_voltar': true
  } )

  const { dadosGlobaisAssociado, modalidadeURL } = useGlobal()
  const [ erros, setErros ] = useState( {} )
  const [ toast, setToast ] = useState( false )
  const [ idAssinatura, setIdAssinatura ] = useState()
  const [ notaSatisfacao, setNotaSatisfacao ] = useState( null )
  const {
    aguardandoCancelamento,
    assinaturaCancelada,
    cancelarAssinatura,
    obterMotivosCancelamento,
    motivosCancelamento
  } = useSolicitacaoCancelamento()

  const motivoSelecionado = motivosCancelamento && state.motivo ? motivosCancelamento[ state.motivo ] : null
  const submotivosBrutos = motivoSelecionado && motivoSelecionado.submotivos && motivoSelecionado.submotivos.length ?
    motivoSelecionado.submotivos : null
  const submotivos = submotivosBrutos
    ? submotivosBrutos.filter( ( item ) => item.codigo !== 'SEM_TEMPO_CONTEUDOS_DIGITAIS' )
    : null

  const handleEtapaAnterior = () => {
    enviaEventoGA( EVENTOS_GA.CANCELAMENTO.FLUXO, EVENTOS_GA.CANCELAMENTO.ACOES_VOLTAR.VOLTOU_CANCELAMENTO )
  }

  useEffect( () => {
    obterMotivosCancelamento()
  }, [] )

  useEffect( () => {
    if ( dadosGlobaisAssociado ) {
      const assinaturaObtida = getAssinaturaDoAssociadoPorModalidade( dadosGlobaisAssociado.assinaturas, modalidadeURL )

      if ( assinaturaObtida ) {
        setIdAssinatura( assinaturaObtida.id )
      }
    }
  }, [ dadosGlobaisAssociado ] )

  useEffect( () => {
    if ( assinaturaCancelada ) {
      navigate( `${URLS.CANCELAR_ASSINATURA_CONCLUSAO}` )
    }
  }, [ assinaturaCancelada ] )

  useEffect( () => {
    if ( notaSatisfacao ) {
      setState( {
        ...state,
        'satisfacao_geral': notaSatisfacao
      } )

      if ( erros.toast ) {
        setErros( {
          ...erros,
          'toast': null
        } )
      }
    }
  }, [ notaSatisfacao ] )

  const handleChangePretendeVoltar = valor => {
    setState( {
      ...state,
      'pretende_voltar': valor === 'Sim'
    } )
  }

  const handleSubmit = () => {
    let errosForm = {}
    if ( !state.motivo || state.motivo === CODIGO_DEFAULT_MOTIVO ) {
      errosForm = {
        ...errosForm,
        'motivo': REQUIRED_MESSAGE
      }
    } else if ( submotivos && ( !state.submotivo || state.submotivo === CODIGO_DEFAULT_SUBMOTIVO ) ) {
      errosForm = {
        ...errosForm,
        'submotivo': REQUIRED_MESSAGE
      }
    }

    if ( !notaSatisfacao ) {
      setToast( true )
      errosForm = {
        ...errosForm,
        'toast': MENSAGEM_SATISFACAO_NAO_PREENCHIDA
      }
    }

    setErros( {
      ...errosForm
    } )

    if ( isEmptyObject( errosForm ) ) {
      cancelarAssinatura( state, idAssinatura )
      enviaEventoGA( EVENTOS_GA.CANCELAMENTO.FLUXO, EVENTOS_GA.CANCELAMENTO.ACOES.CONFIRMAR_CANCELAMENTO )
    }
  }

  const handleChange = event => {
    if ( event.value ) {
      if ( event.campo === 'submotivo' ) {
        setState( {
          ...state,
          'submotivo': event.value
        } )
      } else {
        const { submotivo, ...estadoSemSubmotivo } = state
        setState( {
          ...estadoSemSubmotivo,
          'motivo': event.value
        } )
      }

      const { campo } = event
      if ( !empty( erros[ campo ] ) && event.value !== CODIGO_DEFAULT_MOTIVO && event.value !== CODIGO_DEFAULT_SUBMOTIVO ) {
        setErros( {
          ...erros,
          [ campo ]: null
        } )
      }
    } else {
      const { name, value } = event.target
      setState( {
        ...state,
        [ name ]: value
      } )
    }
  }

  const closeToast = () => {
    setToast( false )
    setErros( {
      ...erros,
      'toast': null
    } )
  }

  return (
    <Fragment>
      <Card
        className="card"
        margin="25px 0"
      >
        <WrapperFormulario>
          { aguardandoCancelamento ?
            <LoadingWrapper>
              <InlineLoader isCenter />
            </LoadingWrapper> : null}

          { toast && erros.toast ?
            <Toast
              close={ closeToast }
              fullWidth={ true }
              message={ erros.toast }
              show={ toast }
              type="error"
            /> : null}

          { motivosCancelamento ?
            <form onSubmit={ handleSubmit }>
              <CardWrapper>
                <div className="conteudoEsquerda">
                  <div className="row">
                    <p className="row--pergunta"> { PERGUNTA_MOTIVO_CANCELAMENTO } </p>

                    <Select
                      className="row--select"
                      erro={ erros.motivo }
                      itens={ Object.keys( motivosCancelamento ).map( item => ( {
                        'campo': 'motivo',
                        'value': motivosCancelamento[ item ].codigo,
                        'visualizacao': motivosCancelamento[ item ].texto }
                      ) ) }
                      label=""
                      name="motivo"
                      onChange={ handleChange }
                      required={ true }
                    />
                  </div>

                  { submotivos ?
                    <div className="row --submotivo">
                      <p className="row--pergunta"> { PERGUNTA_SUBMOTIVO } </p>

                      <Select
                        className="row--select"
                        erro={ erros.submotivo }
                        itens={ [
                          {
                            'campo': 'submotivo',
                            'value': CODIGO_DEFAULT_SUBMOTIVO,
                            'visualizacao': 'Selecione um motivo'
                          },
                          ...submotivos.map( ( item ) => ( {
                            'campo': 'submotivo',
                            'value': item.codigo,
                            'visualizacao': item.texto }
                          ) )
                        ] }
                        key={ state.motivo }
                        label=""
                        name="submotivo"
                        onChange={ handleChange }
                        required={ true }
                      />
                    </div> : null}

                  <div className="row --voltar">
                    <p className="row--pergunta">{ perguntaDisponibilidadeVolta( modalidadeURL ) }</p>

                    <RadioGroup
                      defaultOption={ state.pretende_voltar ? 'Sim' : 'Não' }
                      group="pretende_voltar"
                      itemsDirection="row"
                      itemsPadding="0px 0px 20px 0px"
                      listDirection="row"
                      onChange={ codigo => handleChangePretendeVoltar( codigo.optionChecked ) }
                    >
                      { LISTA_OPCOES.length ? LISTA_OPCOES.map( resposta => (
                        <RadioButton
                          group="pretende_voltar"
                          id={ resposta.valor }
                          key={ resposta.valor }
                          value={ resposta.valor }
                        >
                          <p>{ resposta.valor }</p>
                        </RadioButton>
                      ) ) : null }
                    </RadioGroup>
                  </div>

                  <div className="row">
                    <NivelSatisfacao
                      handleChange={ valor => valor && setNotaSatisfacao( valor ) }
                    />
                  </div>
                </div>

                <div className="conteudoDireita">
                  <div className="row --numero">
                    <p className="row--pergunta --input">{ perguntaQuantidadeLivrosLidos( modalidadeURL ) }</p>

                    <NumberInput
                      name="livros_lidos"
                      onChange={ handleChange }
                      onPressEnter={ handleSubmit }
                      placeholder="Ex.: 5"
                      tipo={ Input.TIPO_TEL }
                      value={ state.livros_lidos }
                    />
                  </div>

                  <div className="row">
                    <p className="row--pergunta --input">Espaço aberto para sugestões, críticas ou elogios!</p>

                    <Input
                      elemento={ Input.ELEMENTO_TEXTAREA }
                      name="experiencia_com_clube"
                      onChange={ handleChange }
                      onPressEnter={ handleSubmit }
                      placeholder="Digite aqui"
                      tipo={ Input.TIPO_TEXTO }
                      value={ state.experiencia_com_clube }
                    />
                  </div>
                </div>
              </CardWrapper>

              { modalidadeURL ?
                <Navegacao
                  eventoBotaoContinuar={ handleSubmit }
                  eventoBotaoVoltar={ handleEtapaAnterior }
                  testIdName="concluir-cancelamento"
                  tituloContinuar={ BOTAO_CONCLUIR_CANCELAMENTO }
                  urlParaVoltar={ `/${modalidadeURL}/${URLS.PLANO}/${URLS.CANCELAR_ASSINATURA_SUSPENSAO}` }
                /> : null}
            </form> : <InlineLoader isCenter />}
        </WrapperFormulario>
      </Card>
    </Fragment>
  )
}

export default MotivosCancelamento


